import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {PageHeader} from 'shells/page-header/page-header';
import {Body} from 'shells/typography/body';

import styles from './report-generating-state.module.css';

type Props = {
    onDiscard: () => void;
};

export function ReportGeneratingState(props: Props) {
    return (
        <div className='pos-relative full-height'>
            <PageHeader
                backButton={{
                    onClick: () => props.onDiscard(),
                    text: 'Discard and exit',
                }}
                title='Smart reports'
            />
            <div className={styles.container}>
                <div style={{width: 500, height: 500}}>
                    <Rive src='/include/rive/reports/report_generator_loading.riv' />
                </div>
                <div className='pos-relative full-width flex justify-center '>
                    <div className={styles['text-container']}>
                        <Body useDoyle={true} color='dark' size='large' isBold={true}>
                            Building the perfect report for you
                        </Body>
                    </div>
                </div>
            </div>
        </div>
    );
}
